import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-helping-page',
  templateUrl: './helping-page.component.html',
  styleUrls: ['./helping-page.component.scss'],
})
export class HelpingPageComponent implements OnInit, AfterViewInit {
  query: any = '';

  constructor(
    private api: MarketingApiService,
    private message: MessageService
  ) {}

  ngOnInit(): void {
    this.findHotarticles();
    this.findArticleCategories();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      window.scrollTo({ top: 0 });
    });
  }

  search() {
    this.getArticle();
  }

  article: any;
  loading = false;
  async getArticle() {
    try {
      this.loading = true;
      const r = await this.api.findArticles(this.query, 0, 1, 10);
      const data = r.data.list[0];
      if (!data) {
        this.message.warn('未找到相关文章');
        return;
      }
      window.location.href =
        `/helping/detail/` + data.tag_id + `/p/` + 1 + `/article/` + data.id;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  hot: any;
  async findHotarticles() {
    try {
      this.loading = true;
      const r = await this.api.findHotarticles();
      this.hot = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  gotoArticle(data: any) {
    window.location.href =
      `/helping/detail/` + data.tag_id + `/p/` + 1 + `/article/` + data.id;
  }

  categories: any[] = [];
  async findArticleCategories() {
    try {
      const r = await this.api.findArticleCategories();
      this.categories = r.data;
    } catch (error) {
    } finally {
    }
  }
}
